import { css } from '@emotion/react';
import { useGetAppointmentColorsEnabled } from '@frontend/schedule-helpers';
import { Dot, Text, Truncated } from '@frontend/design-system';
import type { MockActivityData } from './use-mock-schedule-activity';

type Props = {
  row: MockActivityData;
  isService?: boolean;
};

export const ServiceAndAppointmentTypeCellRenderer = ({ row, isService }: Props) => {
  const { canUseAppointmentColors } = useGetAppointmentColorsEnabled();

  if ((isService && !row?.service?.serviceName) || (!isService && !row?.appointmentType?.appointmentTypeName)) {
    return <Text size='medium'>-</Text>;
  }

  const displayName = isService ? row?.service?.serviceName : row?.appointmentType?.appointmentTypeName;
  const displayColor = isService ? row?.service?.serviceColor : row?.appointmentType?.appointmentTypeColor;

  return (
    <div css={containerStyles}>
      {canUseAppointmentColors && displayColor && (
        <Dot color='warning' css={[{ background: displayColor }, dotStyles]} />
      )}
      <Truncated as={Text} size='medium' weight='bold'>
        {displayName}
      </Truncated>
    </div>
  );
};

const containerStyles = css`
  width: 100%;
  display: flex;
  align-items: center;
  gap: var(--fabric-space-gap-xxs);
`;

const dotStyles = css`
  border: none;
  position: relative;
  min-width: 16px;
`;
